import {
  Container,
  Card,
  Row,
  Col,
  Form,
  ButtonGroup,
  Button,
  Image
} from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment/moment";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {  
  approveReviewMedicalClaims, 
  rejectReviewMedicalClaims,  
  getAttachments,
  updateAttachment,
} from "../../3.Store/ReviewMedicalClaimsSlice";
import { 
  resetClaim,
  editMedicalClaim,
  getAMedicalClaim,
  updateMedicalClaim,
  editMedicalClaimAttachment,
  getMedicalClaimByLeaveApplicationID
} from '../../3.Store/MedicalClaimSlice';
import { getLeaveBalances } from "../../3.Store/ApplicationSlice";
import { ThreeDots } from 'react-loader-spinner';
import { openEditor } from "react-profile";
import DatePicker from "react-datepicker";
import PDFViewer from "../../2.Commons/PDFViewer";

const HRReviewMedicalForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id, leaveApplicationId } = useParams();
  const location = useLocation();
  const details = useSelector(state => state.ReviewMedicalClaimsSlice.details);
  const attachment = useSelector(state => state.ReviewMedicalClaimsSlice.attachment);
  const [loading, setLoading] = useState(false);
  const [fullImage, setFullImage] = useState(null);
  const [hasNewAttachment, setHasNewAttachment] = useState(false);
  const { balance } = useSelector((state) => state.ApplicationSlice);

  const medical_claim = useSelector(state => state.MedicalClaimSlice.medicalClaim);
  // const currentPage = useSelector(state => state.MedicalClaimSlice.currentPage);
  // const attachment = useSelector(state => state.MedicalClaimSlice.attachment);
  // const { balance } = useSelector((state) => state.ApplicationSlice);
  const {
    amount,
    receipt_reference,
    receipt_no,
    claim_date
  } = medical_claim || {};

  console.log(medical_claim);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        if (id) {
          const getMedical = await dispatch(getAMedicalClaim({id})).unwrap();
          await dispatch(getAttachments({ id }));
          await dispatch(getLeaveBalances({ id: getMedical.employee.id }));
        } 
        else if (leaveApplicationId) {
          const getMedical = await dispatch(getMedicalClaimByLeaveApplicationID({ id: leaveApplicationId })).unwrap();
          
          // ❗ If no medical claim found
          if (!getMedical || !getMedical.id) {
            Swal.fire({
              icon: 'warning',
              text: 'No medical claim for this sick leave application',
              confirmButtonText: 'OK',
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                navigate(-1); // Navigate back only after user clicks OK
              }
            });
          }          

          const claimID = getMedical.id;
          await dispatch(getAttachments({ id:claimID }));
          await dispatch(getLeaveBalances({ id: getMedical.employee.id }));
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchData();
    window.scrollTo(0, 0);
  }, [id, leaveApplicationId]);

  // useEffect(() => {
  //   setLoading(true);
  //   window.scrollTo(0, 0);
  //   if (id) {
  //     dispatch(getAMedicalClaim({id}))
  //       .then(() => {
  //         setHasNewAttachment(false);
  //         setLoading(false);
  //         dispatch(getAttachments({id}))
  //       })
  //   }
  //   else if (leaveApplicationId) {
  //     const getMedical = dispatch(getMedicalClaimByLeaveApplicationID({ id: leaveApplicationId })).unwrap();
  //     const claimID = getMedical.id;
  //     dispatch(getAMedicalClaimAttachment({ id:claimID })).then(() => {
  //       setLoading(false);
  //       setHasNewAttachment(false);
  //     });
  //     // dispatch(getLeaveBalances({ id: userId }));
  //   }
  // }, [id, leaveApplicationId]);

  const handleBtnReject = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        console.log(details.id)
        dispatch(rejectReviewMedicalClaims([medical_claim.id]))
          .unwrap()
          .then(() => {
            setLoading(false);
            Swal.fire("Medical Claim Rejected", "", "success", "OK")
            .then(() => {
              // navigate(`/HRReviewMedicalList`);
              handleBtnBack();
            })
          })
          .catch((err) => {
            Swal.fire("Error", err.response.data, "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'The rejection has been cancelled',
            'error'
          );
      }
    });
  };

  const handleBtnBack = () => {
    if (leaveApplicationId) {
      navigate(-1);
    }
    else{
      const queryParams = new URLSearchParams(location.search);
      const currentPage = queryParams.get('currentPage') || 1;
      const searchText = queryParams.get('searchText') || ''; // Retrieve search text from query parameters
      const fromDate = queryParams.get('fromDate') || '';
      const toDate = queryParams.get('toDate') || '';
      navigate(`/HRReviewMedicalList?currentPage=${currentPage}&searchText=${searchText}&fromDate=${fromDate}&toDate=${toDate}`); // Navigate back with current page and search text
    }
    // const queryParams = new URLSearchParams(location.search);
    // const currentPage = queryParams.get('currentPage') || 1;
    // const searchText = queryParams.get('searchText') || ''; // Retrieve search text from query parameters
    // const fromDate = queryParams.get('fromDate') || '';
    // const toDate = queryParams.get('toDate') || '';
    // navigate(`/HRReviewMedicalList?currentPage=${currentPage}&searchText=${searchText}&fromDate=${fromDate}&toDate=${toDate}`); // Navigate back with current page and search text
  };

  const handleBtnApprove = () => {
    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        dispatch(approveReviewMedicalClaims([medical_claim.id]))
          .unwrap()
          .then(() => {
            setLoading(false);
            Swal.fire("Medical Claim Approved", "", "success", "OK")
            .then(() => {
              // navigate(`/HRReviewMedicalList`);
              handleBtnBack();
            })
          })
          .catch((err) => {
            Swal.fire("Error", err.response.data, "error", "OK");
          });
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'The approval has been cancelled',
            'error'
          );
      }
    });
  };
  
  const handleAttachmentChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];

    if (!allowedTypes.includes(selectedFile.type)) {
      Swal.fire({
        text: "Only JPG, PNG, or PDF files are allowed. / Hanya fail JPG, PNG atau PDF dibenarkan.",
        icon: "warning",
        confirmButtonText: "OK"
      });
  
      event.target.value = null;
  
      const entity = {
        ...attachment,
        file: "",
        filename: "",
        filetype: "",
        filesize: ""
      };
      dispatch(updateAttachment(entity));
      return;
    }

    setLoading(true); // Adjust this if you're using a different loading state

    const reader = new FileReader();

    reader.onloadend = () => {
      const fileResult = reader.result;
  
      if (selectedFile.type === 'application/pdf') {
        const base64String = fileResult.split(',')[1];
        finishUpload(base64String);
      } else {
        setFullImage(fileResult);
        setLoading(false);
  
        openEditor({ src: selectedFile })
          .then(editor => {
            const base64String = editor?.editedImage?.getDataURL();
            if (!base64String) {
              setLoading(false);
              return;
            }
            finishUpload(base64String);
          })
          .catch(error => {
            console.error("Editor error:", error);
            Swal.fire({
              text: "There was an error editing the image.",
              icon: "error",
              confirmButtonText: "OK"
            });
            setLoading(false);
          });
      }
    };

    reader.onerror = () => {
      Swal.fire({
        text: "Error reading file.",
        icon: "error",
        confirmButtonText: "OK"
      });
      setLoading(false);
    };

    reader.readAsDataURL(selectedFile);

    function finishUpload(base64String) {
      const entity = {
        ...attachment,
        file: base64String,
        filename: selectedFile.name,
        filetype: selectedFile.type,
        filesize: selectedFile.size
      };

      dispatch(updateAttachment(entity));
      setHasNewAttachment(true);
      console.log("Base64 File:", base64String);
      console.log("Filename:", selectedFile.name);
      console.log("Filetype:", selectedFile.type);
      console.log("Filesize:", selectedFile.size, "bytes");

      setTimeout(() => {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }, 500);
    }
  };
  
  const handleBtnUpdateCert = () => {
    if (!attachment.file) {
      Swal.fire({
        title: "Please upload medical certificate",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    if (!hasNewAttachment) {
      Swal.fire({
        title: "Please upload a new medical certificate before updating.",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    if(!claim_date || !amount || !receipt_no || !receipt_reference){
      Swal.fire({
        title: "Please fill in the details",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    if(amount <= 0){
      Swal.fire({
        title: "Please enter the correct amount",
        icon: "warning",
        confirmButtonText: "OK"
      });
      return;
    }

    Swal.fire({
      title: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        if(leaveApplicationId){
          dispatch(editMedicalClaim({ id: medical_claim.id, ...medical_claim })).unwrap();
          dispatch(editMedicalClaimAttachment({ ...attachment, id: medical_claim.id })).unwrap()
          .then(() => {
            setHasNewAttachment(false); // reset after update
            setLoading(false);
            Swal.fire("Medical Claim Updated", "", "success", "OK").then(() => {
              handleBtnBack();
            });
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
        }
        else {
          dispatch(editMedicalClaim({ id: id, ...medical_claim })).unwrap();
          dispatch(editMedicalClaimAttachment({ ...attachment, id: id })).unwrap()
          .then(() => {
            setHasNewAttachment(false); // reset after update
            setLoading(false);
            Swal.fire("Medical Claim Updated", "", "success", "OK").then(() => {
              handleBtnBack();
            });
          })
          .catch((err) => {
            Swal.fire("Error", err.response?.data || 'An error occurred', "error", "OK");
          });
        }
      }
    });
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
  
    // ✅ Allow only numbers and at most one decimal point for "amount"
    if (name === "amount" && !/^\d*\.?\d*$/.test(value)) {
      return; // Reject non-numeric input
    }
  
    const entity = { ...medical_claim, [name]: value };
    console.log(entity);
    dispatch(updateMedicalClaim(entity));
    setHasNewAttachment(true);
  };  

  return (
    <Container className="ContainerContent">
      {loading && (
        <ThreeDots
          visible={true}
          height="80"
          width="80"
          color="#4fa94d"
          radius="9"
          ariaLabel="three-dots-loading"
          wrapperStyle={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: '9999',
          }}
        />
      )}
      <Card className="CardContent2">
        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>
        </div>
        <h1 className="TitleHeader">HR Review Medical Claim</h1>
        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Staff Name</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control value={medical_claim?.employee?.fullname} readOnly disabled/>
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Invoice Date</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            {/* <Form.Control name="claim_date" value={moment(claim_date).format("YYYY-MM-DD")} onChange={handleFormChange}/> */}
            <DatePicker
              selected={claim_date ? new Date(claim_date) : null}
              onChange={(date) =>
                handleFormChange({
                  target: {
                    name: "claim_date",
                    value: moment(date).format("YYYY-MM-DD"),
                  },
                })
              }
              dateFormat="yyyy-MM-dd"
              className="form-control w-100 datepicker-icon"
            />
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Practitioner</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="receipt_no" value={receipt_no} onChange={handleFormChange} />
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Claim (RM) Balance RM{balance?.medical_benefit}</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="amount" value={amount} onChange={handleFormChange} />
          </Col>
        </Row>

        <Row className="my-3">
          <Col md={6} sm={6}>
            <Form.Label className="FormLabel fw-normal fs-5">Receipt No</Form.Label>
          </Col>
          <Col md={6} sm={6}>
            <Form.Control name="receipt_reference" value={receipt_reference} onChange={handleFormChange} />
          </Col>
        </Row>

        <Row className="my-2">
            <Col md={6} sm={6}>
              <Form.Label className="FormLabel fw-normal fs-5">Change Medical Certificate</Form.Label>
            </Col>
            <Col md={6} sm={6}>
              {/* <Form.Control type="file" onChange={handleAttachmentChange}/> */}
              <Form.Control type="file" onChange={handleAttachmentChange}/>
            </Col>
          </Row>

        {/* Conditional rendering based on attachment existence */}
        {attachment && attachment.file && (
          <Row className="my-3">
            <Col md={12} sm={12} className="d-flex justify-content-center align-items-center">
              {/* Display image */}
              {attachment.filetype?.startsWith('image/') && (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '10px',
                    backgroundColor: '#373c40',
                    height: '500px',
                    width: "100%",
                    overflow: 'auto',
                  }}
                >
                  <Image
                    src={attachment.file}
                    alt="Uploaded file"
                    fluid
                    style={{
                      maxWidth: '100%',
                      height: '100%',
                    }}
                  />
                </div>
              )}

              {/* Display PDF */}
              {!attachment.filetype?.startsWith('image/') && (
                <div style={{ width: "100%" }}>
                  <PDFViewer base64Data={attachment.file} height="500px" width="100%" />
                </div>
              )}
            </Col>
          </Row>
        )}

        <div className="d-flex justify-content-between">
          <ButtonGroup className="my-2">
            <Button className="Button" onClick={handleBtnBack}>
              Back
            </Button>
          </ButtonGroup>

          <ButtonGroup className="my-2">
            {hasNewAttachment && (
              <Button className="Button" onClick={handleBtnUpdateCert}>
                Update
              </Button>
            )}
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnReject}>
              Reject
            </Button>
            &nbsp; &nbsp;
            <Button className="Button" onClick={handleBtnApprove}>
              Approve
            </Button>
          </ButtonGroup>
        </div>
      </Card>
    </Container>
  );
};
export default HRReviewMedicalForm;
